<template>
  <div>
    <h1>{{ convertToDate(day) }}</h1>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="4"
        v-for="(slot, index) in availableSlots"
        :key="index"
      >
        <v-card
          v-if="shouldShowToUser(slot)"
          class="mx-auto mb-2"
          :class="{ available: slotIsAvailable(slot) }"
        >
          <v-card-text>
            <div class="text--primary">
              <h2 class="display-1">{{ slot.starts_at }}</h2>
            </div>
            <div>Appointment Slot</div>
            <p class="green--text" v-if="slotIsAvailable(slot)">
              This time is available
            </p>
            <p class="red--text" v-if="!slotIsAvailable(slot)">
              {{ unavailableText }}
            </p>

            <div v-if="!admin">
              <booking-modal
                :currentSlot="slot"
                :slotIndex="realIndex(slot)"
                :selectedDateAndTime="selectedDateAndTime(slot)"
                :day="day"
              />
            </div>
            <div class="d-flex align-center justify-space-between" v-else>
              <v-btn
                :disabled="slotIsAvailable(slot)"
                small
                elevation="0"
                color="success secondary--text"
                @click="approveSlot(slot, index)"
                >Activate</v-btn
              >
              <v-btn
                :disabled="!slotIsAvailable(slot)"
                elevation="0"
                small
                color="warning secondary--text"
                @click="unapproveSlot(slot, index)"
                >Deactivate</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import { db } from "../firebase/firebase";
import UtilsMixin from "../mixins/UtilsMixin";
import BookingModal from "./BookingModal.vue";

export default {
  name: "Day",
  components: {
    BookingModal,
  },
  props: {
    day: {
      type: Object,
      required: true,
    },
    admin: Boolean,
  },
  computed: {
    availableSlots() {
      return this.admin
        ? this.day.slots
        : this.day.slots.filter((slot) => !slot.booked && slot.approved);
    },
    unavailableText() {
      return this.admin ? "This slot is not active" : "Sorry, its booked!";
    },
  },
  mixins: [UtilsMixin],
  firestore() {
    return {
      calEvent: db.collection("calEvent"),
      users: db.collection("users"),
    };
  },
  methods: {
    realIndex(slot) {
      return _.findIndex(this.day.slots, slot);
    },
    shouldShowToUser(slot) {
      return this.admin || this.slotIsAvailable(slot);
    },
    slotIsAvailable(slot) {
      return !slot.booked && slot.approved;
    },
    approveSlot(slot, index) {
      this.$store
        .dispatch("approveAppointmentAction", { slot, index, day: this.day })
        .catch((err) => this.$store.commit("setError", err));
    },
    unapproveSlot(slot, index) {
      this.$store
        .dispatch("unapproveSlotAction", { slot, index, day: this.day })
        .catch((err) => this.$store.commit("setError", err));
    },
    selectedDateAndTime(slot) {
      return this.convertToDate(this.day) + " at " + slot.starts_at;
    },
    isWeekend(momentDay) {
      return momentDay.day() === 0 || momentDay.day() === 6;
    },
  },
  mounted() {
    // scroll to first available appointment
    const availableAppointments = document.querySelectorAll(".available");
    if (availableAppointments.length > 0) {
      let target = availableAppointments[0];
      let scrollPos = (target.parentNode.scrollTop = target.offsetTop);
      window.scroll({ top: scrollPos, behavior: "smooth" });
    }
  },
};
</script>
